module.exports = __webpack_public_path__ + "img/banner-product.476b798f.jpg";